<template>
  <main class="main cookies max-width">	
    <article>
      <h1 class="title-medium">Cookie policy</h1>

      <h2>I cookie</h2>
      <p>Per far funzionare bene questo sito, a volte installiamo sul tuo dispositivo dei piccoli file di dati che si chiamano "cookie". Anche la maggior parte dei grandi siti fanno lo stesso.</p>

      <h2>Cosa sono i cookie?</h2>
      <p>Un cookie è un piccolo file di testo che i siti salvano sul tuo computer o dispositivo mobile mentre li visiti. Grazie ai cookie il sito ricorda le tue azioni e preferenze (per es. login, lingua, dimensioni dei caratteri e altre impostazioni di visualizzazione) in modo che tu non debba reinserirle quando torni sul sito o navighi da una pagina all'altra.</p>

      <h2>Come utilizziamo i cookie?</h2>
      <p>In alcune pagine utilizziamo i cookie per ricordare se hai autorizzato l'uso dei cookie sul sito.</p>
      <p>Inoltre, alcuni video inseriti nelle nostre pagine utilizzano un cookie per elaborare statistiche, in modo anonimo, su come sei arrivato sulla pagina e quali video hai visto. Infine, viene utilizzato Google Analytics per avere a disposizione statistiche sull'utilizzo del sito da parte degli utenti, che ci aiutano a migliorare l'esperienza.</p>
      <p>Non è necessario abilitare i cookie perché il sito funzioni, ma farlo migliora la navigazione. È possibile cancellare o bloccare i cookie, però in questo caso alcune funzioni del sito potrebbero non funzionare correttamente.</p>
      <p>Le informazioni riguardanti i cookie non sono utilizzate per identificare gli utenti e i dati di navigazione restano sempre sotto il nostro controllo. Questi cookie servono esclusivamente per i fini qui descritti.</p>

      <h2>Come controllare i cookie?</h2>
      <p>Puoi controllare e/o verificare i cookie come vuoi – per saperne di più, vai su <a href="http://www.aboutcookie.org" target="_blank" rel="external noopener nofollow">aboutcookie.org</a>. Puoi cancellare i cookie già presenti nel computer e impostare quasi tutti i browser in modo da bloccarne l'installazione. Se scegli questa opzione, dovrai però modificare manualmente alcune preferenze ogni volta che visiti il sito ed è possibile che alcuni servizi o determinate funzioni non siano disponibili.</p>

      <h2>Come disabilitare i cookie?</h2>
      <p>Ogni utente può disabilitare l'utilizzo di cookie attraverso il browser con il quale naviga sul web.<br>Di seguito i documenti di riferimento che dettagliano come disabilitare i cookie sul proprio browser:</p>
      <ul>
        <li><a target="_blank" rel="external noopener nofollow" href="https://support.microsoft.com/it-it/help/17442/windows-internet-explorer-delete-manage-cookies">Internet Explorer</a></li>
        <li><a target="_blank" rel="external noopener nofollow" href="https://support.google.com/chrome/answer/95647?hl=it-IT&amp;p=cpn_cookie">Google Chrome</a></li>
        <li><a target="_blank" rel="external noopener nofollow" href="https://support.mozilla.org/it/kb/Attivare%20e%20disattivare%20i%20cookie">Mozilla Firefox</a></li>
        <li><a target="_blank" rel="external noopener nofollow" href="https://support.apple.com/it-it/HT201265">Apple Safari</a></li>
      </ul>
      <p>Per disabilitare il tracciamento attraverso Google Analytics, fare riferimento al modulo nella parte bassa del pié di pagina di questo sito, oppure all'estensione dedicata fornita da Google <a href="https://tools.google.com/dlpage/gaoptout">a questo link</a>.</p>

      <h2>Quali cookie non tecnici sono in uso?</h2>
      <ul>
        <li>Youtube: cookie di profilazione di terze parti</li>
        <li>Google Analytics: cookie analitici di prime parti</li>
      </ul>
    </article>
  </main>
</template>

<script>
export default {
  name: 'Cookies',
  mounted() {
    document.title = 'Caramba - Cookie Policy';
  }
}
</script>




// WEBPACK FOOTER //
// src/vue/components/Cookies.vue